export default __webpack_public_path__ + "static/media/blob3.781ea0f9.svg";